/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/terms/tools.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App components
import { Link } from '@client/components';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- TABS
----------------------------------*/
const TermsTabs = ({
  current
}: {
  current: 'tools' | 'marketplace' | 'csm' | 'teamLeader' | 'businessPartner' | 'dealPartner' | 'ambassadors';
}) => {
  const base = 'px-4 py-2 rounded-lg text-sm font-semibold transition-colors';
  const active = 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow';
  const inactive = 'text-slate-700 hover:text-orange-600 hover:bg-orange-50';
  return <div className="flex flex-wrap items-center gap-2 bg-orange-50 border border-orange-100 rounded-xl p-2">
            <Link to="/terms" className={`${base} ${current === 'tools' ? active : inactive}`}>
                Tools
            </Link>
            <Link to="/terms/marketplace" className={`${base} ${current === 'marketplace' ? active : inactive}`}>
                Marketplace
            </Link>
            <Link to="/terms/csm" className={`${base} ${current === 'csm' ? active : inactive}`}>
                CSM
            </Link>
            <Link to="/terms/team-leader" className={`${base} ${current === 'teamLeader' ? active : inactive}`}>
                Team Leader
            </Link>
            <Link to="/terms/business-partner" className={`${base} ${current === 'businessPartner' ? active : inactive}`}>
                Business Partner
            </Link>
            <Link to="/terms/deal-partner" className={`${base} ${current === 'dealPartner' ? active : inactive}`}>
                Deal Partner
            </Link>
            <Link to="/terms/ambassadors" className={`${base} ${current === 'ambassadors' ? active : inactive}`}>
                Ambassadors
            </Link>
        </div>;
};

/*----------------------------------
- PAGE: TOOLS TERMS
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/terms', { ...({
  static: {
    refresh: '1h',
    urls: ['/terms']
  }
}), ...{ filepath: "/app/client/pages/terms/tools.tsx", sourceLocation: { line: 54, column: 1 }, id: "terms_tools" } }, null, ({}) => {
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-4xl mx-auto">
                <div className="mb-6">
                    <TermsTabs current="tools" />
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                    <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-2">
                        CrossPath General Terms & Conditions of Use
                    </h1>
                    <p className="text-slate-600 text-sm mb-8">as of October 15, 2025</p>

                    <div className="prose prose-slate max-w-none">
                        <p className="text-slate-700 mb-6">
                            THESE GENERAL TERMS OF SERVICE (the “Terms”) are a legal and binding agreement between
                            CrossPath (the “Service Provider”, “we”, “us”) and you, or if you represent an employer or
                            client, then that employer or client (“you” or the “Client”), governing your use of
                            CrossPath’s website (<span className="whitespace-nowrap">https://www.becrosspath.com</span>
                            ), the tools and services for talent acquisition, marketplace and recruitment operations,
                            and all other related services that CrossPath provides (collectively the “Services”).
                        </p>
                        <p className="text-slate-700 mb-6">
                            CrossPath reserves the right to change or update these Terms at any time, at its sole
                            discretion, by posting an update on the website or by providing notice, if possible at least
                            30 days before the effective date. Your rights under these Terms will be subject to the most
                            current version posted on the website.
                        </p>
                        <p className="text-slate-700 mb-6">
                            PLEASE CAREFULLY READ THESE TERMS. BY SUBSCRIBING OR BY ACCESSING OR USING THE WEBSITE OR
                            THE SERVICES, YOU AGREE THAT YOU HAVE READ AND AGREE, WITHOUT RESERVATIONS, TO BE BOUND BY
                            THE LATEST VERSION OF THE AGREEMENT, BEING THE FOLLOWING DOCUMENTS (LISTED BY ORDER OF
                            PRIORITY): (1) any Specific Terms (defined below in Article 1), if any; (2) these Terms; (3)
                            the Operating Policies (including our Privacy Policy and Acceptable Use Policy). The
                            Services are exclusively reserved for a professional use and are not available to minors
                            under the age of 18.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 1. Definitions</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                <span className="font-semibold">Assistance Services</span>: any consulting,
                                configuration, onboarding, training, and implementation services provided by the Service
                                Provider to enable Client’s access to and use of the Services, including API
                                integrations and data imports. Assistance Services include consulting services,
                                onboarding and training, as well as related services.
                            </li>
                            <li>
                                <span className="font-semibold">Data</span>: Client’s electronic data, whether or not
                                personal data, that is collected, managed, processed, and/or shared by Client and the
                                Service Provider, and which may be intended for third parties, through the Service.
                            </li>
                            <li>
                                <span className="font-semibold">Service</span>: the CrossPath hosted application and
                                platform made available by the Service Provider and remotely executed by the Client,
                                including features related to candidate sourcing, workflow management, communications,
                                marketplace interactions, analytics, and integrations. The Service Provider may adapt,
                                arrange, and/or modify components of the Service and associated documentation provided
                                maintenance and support commitments are upheld.
                            </li>
                            <li>
                                <span className="font-semibold">Intellectual Property Right</span>: all industrial
                                property and copyrights including patents, trademarks, designs and models, copyrights
                                (including audiovisual effects, graphical interfaces, preparatory design material,
                                software and source code), specifications, and documentation.
                            </li>
                            <li>
                                <span className="font-semibold">Operating Policies</span>: the operational rules,
                                guidelines, and processes followed by the Service Provider in the operation of the
                                Services, with which Client’s compliance may be required. The Operating Policies include
                                the Privacy Policy and Acceptable Use Policy, as updated from time to time, and are
                                incorporated herein.
                            </li>
                            <li>
                                <span className="font-semibold">Specific Terms</span>: all specific terms and conditions
                                mutually agreed with the Client stating in particular the financial and technical
                                elements specified in an order form, quotation, or statement of work.
                            </li>
                            <li>
                                <span className="font-semibold">Website</span>: the web pages associated with the
                                technological features of the Service described in the documentation and accessible by
                                Client (including administrative interfaces) in accordance with the Agreement.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 2. Support and Service Levels</h2>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">2.1</h3>
                        <p className="text-slate-700 mb-6">
                            We shall use reasonable efforts, consistent with industry standards, to provide reliable
                            platform availability and routing of communications within the Service. We may offer
                            optional services intended to improve usage or outcomes. Such additional services are
                            invoiced separately and provided after your acceptance of a quotation, as referenced in the
                            Specific Terms.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">2.2 Support and Service Levels</h3>
                        <p className="text-slate-700 mb-4">
                            You shall designate an administrator (the “Administrator”) to collect information and
                            support requests from your users and to attempt initial resolution. We provide second‑level
                            support to the Administrator, which consists of: (i) responding to the Administrator’s
                            requests for information and support related to use of the Service; and (ii) resolving
                            anomalies the Administrator could not fix despite reasonable first‑level efforts. The
                            Administrator may contact support at
                            <a className="underline" href="mailto:team@becrosspath.com">
                                team@becrosspath.com
                            </a>{' '}
                            with sufficient detail to enable diagnosis.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 3. Use of the Services</h2>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">3.1 Use of the Services</h3>
                        <p className="text-slate-700 mb-4">
                            You shall comply with these Terms and the Operating Policies and ensure your users do the
                            same. You shall not interfere with or disrupt operation of the Service. If you use any APIs,
                            you are responsible for reasonable usage and rate limits. You access the Services in your
                            own name and on your own behalf and may not assign or resell the Services unless expressly
                            permitted in the Specific Terms (e.g., via authorized sub-accounts).
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">3.2 Credentials</h3>
                        <p className="text-slate-700 mb-4">
                            When creating an account, you agree to provide accurate information and keep it up to date.
                            You are responsible for maintaining the confidentiality of all credentials, user IDs, and
                            passwords, and for promptly notifying us of any unauthorized use or loss. Each account is
                            personal to you or your authorized users. We may request proof of identity or authority
                            before restoring access.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">3.3 Content</h3>
                        <p className="text-slate-700 mb-4">
                            You are solely responsible for any data, information, or content processed via the Service
                            (“Content”), including content provided by third parties or through integrations, and for
                            compliance with applicable laws and these Terms. Content must not: (i) infringe third‑party
                            rights; (ii) contain malware; (iii) be unlawful, harassing, defamatory, obscene, deceptive,
                            or otherwise objectionable; (iv) include sensitive personal data unless expressly permitted
                            and adequately protected; or (v) violate the Operating Policies. We may take reasonable
                            actions (including removal or suspension) to prevent unlawful activity. You are responsible
                            for maintaining appropriate backups of your Content.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">3.4 Acceptable Use</h3>
                        <p className="text-slate-700 mb-6">
                            You undertake to comply with our Acceptable Use Policy. In case of breach or unusual
                            complaint rates, we may limit usage, suspend, or terminate accounts. Fees remain payable
                            during any temporary limitation period.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 4. Compliance with the Law</h2>
                        <p className="text-slate-700 mb-6">
                            You shall comply with all laws and regulations applicable in each jurisdiction from which
                            you access the Website and/or use the Service and in each jurisdiction to which you send
                            communications or process data, and you shall indemnify us from losses arising from your
                            non‑compliance. We shall: (i) obtain and maintain necessary licenses and consents; (ii)
                            comply with reasonable rules and security procedures; (iii) use best efforts to make the
                            Services available per any service level commitments set out in the Specific Terms,
                            excluding planned downtime notified in advance; (iv) maintain appropriate technical,
                            administrative, and physical safeguards to protect your data; (v) promptly notify you of any
                            actual or suspected security breach involving your data; (vi) reasonably cooperate with you
                            in related investigations or remediation; and (vii) comply with applicable data protection
                            laws (e.g., GDPR, CCPA) and implement industry‑standard security controls. We will provide
                            evidence upon reasonable request.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 5. Access Terms</h2>
                        <p className="text-slate-700 mb-4">
                            We may offer access packages with or without fixed commitment periods. Applicable commercial
                            conditions are defined in the Specific Terms. Free access packages are subject to usage
                            limits as published. You may upgrade or terminate a free access package at any time.
                        </p>
                        <p className="text-slate-700 mb-4">
                            Financial conditions, where applicable, are set forth in the Specific Terms. Unless stated
                            otherwise, minimum commitments are non-cancelable and non-refundable. Access may renew
                            automatically on the same basis. You may terminate at any time; however, prepaid amounts are
                            not refunded. You remain responsible for amounts due until the effective termination date.
                            Access terms exclude equipment and internet access costs. We may update commercial
                            conditions with prior notice; for fixed-term access, updates apply upon renewal if mutually
                            agreed.
                        </p>
                        <p className="text-slate-700 mb-6">
                            Any payment delay may result in late interest, collection costs, suspension of access,
                            and/or termination after notice. All amounts are exclusive of taxes; you are responsible for
                            applicable taxes.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 6. Termination</h2>
                        <p className="text-slate-700 mb-4">
                            Either party may terminate the Agreement for a material breach not cured within thirty (30)
                            days after written notice. We may immediately suspend or terminate for unlawful activity,
                            policy violations, security breaches or attempts, fraud, or payment failures. For free
                            plans, we may terminate at any time upon reasonable notice.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">Consequences of termination</h3>
                        <p className="text-slate-700 mb-6">
                            Upon expiration or termination, all amounts owed become immediately due. We do not refund
                            prepaid fees. As of the effective termination date, your access ends. We will use
                            commercially reasonable efforts to delete or return your data consistent with our data
                            retention and deletion policies and applicable law, subject to any archival backups retained
                            under standard retention practices.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">
                            Article 7. Intellectual Property – Access and Use Rights
                        </h2>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">7.1 Trademarks</h3>
                        <p className="text-slate-700 mb-4">
                            The service name “CrossPath” and related marks are trademarks of the Service Provider. You
                            may not use any such trademarks without our prior written consent. Other trademarks on the
                            Website are the property of their respective owners.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">7.2 Copyrights</h3>
                        <p className="text-slate-700 mb-4">
                            Site elements (e.g., graphical interface, logos, headers, icons, service names, text, and
                            software) are protected by copyright and remain the property of their authors. You may not
                            use, copy, modify, create derivative works, or distribute such content without
                            authorization, nor reverse engineer or decompile software except as permitted by law.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">7.3 Right of Access and Use</h3>
                        <p className="text-slate-700 mb-4">
                            Subject to full payment of applicable fees, we grant you a limited, non‑exclusive,
                            non‑transferable, personal and temporary right to access and use the Service. No
                            intellectual property rights are assigned to you.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">7.4 Exclusive rights</h3>
                        <p className="text-slate-700 mb-4">
                            We retain the exclusive right to modify and correct the Service. We remain the owner of all
                            intellectual property rights protecting the works and services performed in connection with
                            the Services, associated documentation, and all copies, derivatives, modifications, and
                            enhancements thereof.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">
                            7.5 Intellectual property related to the Data
                        </h3>
                        <p className="text-slate-700 mb-4">
                            If the Data (excluding personal data) is protected by intellectual property rights, you
                            grant CrossPath, free of charge, for the duration of this Agreement and thereafter to the
                            extent permitted by law, a right to use such Data as necessary to provide, maintain, and
                            improve the Services.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">7.6 Your rights</h3>
                        <p className="text-slate-700 mb-6">
                            You remain the sole owner of your materials and data. We have no rights to your materials
                            except as necessary to provide the Services during the term and as otherwise permitted by
                            these Terms.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 8. Warranties</h2>
                        <p className="text-slate-700 mb-6">
                            We use reasonable efforts to deliver a functional Service substantially in accordance with
                            its documentation, but do not warrant an error‑free service. If you notice non‑compliance,
                            notify us and we will use reasonable efforts to remedy it; this is your sole and exclusive
                            remedy. You warrant that you have the right and authority to subscribe to and use the
                            Services and that the data and content you provide are accurate and up to date.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 9. Limitation of Liability</h2>
                        <p className="text-slate-700 mb-6">
                            The Website may include links to other websites. We do not control these sites and are not
                            responsible for their availability or content. We may temporarily suspend access for
                            maintenance and will endeavor to keep interruptions to a minimum. Neither party (including
                            its third‑party suppliers, employees, or representatives) shall be liable for indirect or
                            consequential damages (including loss of revenue, profits, business, or data). In all cases,
                            each party’s total liability is limited to the amount paid by you for the Services during
                            the twelve (12) months preceding the event giving rise to liability, except for damages that
                            cannot be limited under applicable law.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 10. Confidentiality</h2>
                        <p className="text-slate-700 mb-6">
                            Each party agrees to treat as confidential, and not reproduce or disclose except as
                            necessary to perform the Agreement, the information and documents exchanged between them.
                            Each party shall ensure that its personnel and contractors adhere to the same
                            confidentiality obligations. Breach may cause irreparable harm; equitable relief may be
                            sought in addition to other remedies. Public information and legally required disclosures
                            are excluded.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 11. Miscellaneous</h2>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">11.1 Transfer – Change of Control</h3>
                        <p className="text-slate-700 mb-4">
                            Your right to access and use the Service is personal, temporary, non‑transferable, and
                            non‑exclusive. You may not transfer the Agreement or any rights to a third party without our
                            prior written consent.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">11.2 Subcontracting</h3>
                        <p className="text-slate-700 mb-4">
                            We may use subcontractors to provide services in connection with the Services and remain
                            responsible for their performance in accordance with these Terms.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">11.3 Entire Agreement</h3>
                        <p className="text-slate-700 mb-4">
                            These Terms, together with the Operating Policies and any Specific Terms, constitute the
                            entire agreement between you and us and supersede prior commitments regarding the subject
                            matter. Modifications require a written amendment signed by both parties.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">11.4 Severability</h3>
                        <p className="text-slate-700 mb-4">
                            If any provision is deemed invalid, the remaining provisions remain in full force and
                            effect.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">11.5 Force Majeure</h3>
                        <p className="text-slate-700 mb-4">
                            Neither party is responsible for any failure or delay due to events beyond its reasonable
                            control (Force Majeure). If a Force Majeure event continues for more than sixty (60) days
                            and materially affects obligations, either party may terminate upon written notice.
                        </p>
                        <h3 className="text-lg font-bold text-slate-900 mb-2">11.6 Governing Law – Jurisdiction</h3>
                        <p className="text-slate-700 mb-6">
                            These Terms are governed by French law. Failing amicable settlement, disputes are subject to
                            the exclusive jurisdiction of the courts of Paris, France, notwithstanding multiple
                            defendants or third‑party claims.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">Article 12. Your Data</h2>
                        <p className="text-slate-700 mb-4">
                            “Your Data” means any data and content stored or transmitted via the Services by or on
                            behalf of you or your end‑users (which may include data imported from third‑party services).
                            You retain full ownership of Your Data; we do not claim ownership.
                        </p>
                        <p className="text-slate-700 mb-4">
                            You grant us the rights necessary to transmit, store, copy, display, index, and back up Your
                            Data solely to provide the Services and comply with law. This permission includes use of
                            third‑party service providers (e.g., cloud infrastructure) to the extent necessary to
                            operate the Services.
                        </p>
                        <p className="text-slate-700 mb-4">
                            You are responsible for your conduct, Your Data, and communications with others while using
                            the Services, including obtaining required rights and permissions and preventing
                            unauthorized access or use. You will notify us promptly of any such unauthorized access or
                            use.
                        </p>
                        <p className="text-slate-700 mb-6">
                            CrossPath processes personal data on your behalf as a processor where applicable. These
                            Terms incorporate any applicable Data Processing Agreement (DPA). By accepting these Terms,
                            you accept the DPA. You can request a countersigned copy or contact us at
                            <a className="underline" href="mailto:team@becrosspath.com">
                                team@becrosspath.com
                            </a>
                            .
                        </p>
                    </div>
                </div>
            </div>
        </Page>;
});
};
